import { render, staticRenderFns } from "./UnderlineLink.vue?vue&type=template&id=02646e58&"
import script from "./UnderlineLink.vue?vue&type=script&lang=js&"
export * from "./UnderlineLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports